import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const addReturnAnalytics = (shipmentDetails, step, faultyData = []) => {
  const {
    productDescription,
    productDimension,
    productId,
    productName,
    quantity,
    quantityTotalPrice,
    returnData,
    productCategory,
    basePrice,
    taxAmount,
    totalAmount,
    currency,
  } = shipmentDetails
  const isFaultyAvailable = faultyData.length > 0
  let eventAction,
    eventName,
    eventMsg,
    internalLinkName,
    internalLinkType,
    internalLinkURL
  switch (step) {
    case "one":
      eventAction = "returnItem:Init:Next"
      eventName = "returnItem:Init:Next"
      eventMsg = "return initiated - next step"
      internalLinkName = "return next"
      internalLinkType = "return:init:next"
      internalLinkURL = "/return/next"
      break
    case "two":
      eventAction = "returnItem:UploadImage:Next"
      eventName = "returnItem:UploadImage:Next"
      eventMsg = "return image uploaded - next step"
      internalLinkName = "return upload image next"
      internalLinkType = "return:uploadImage:next"
      internalLinkURL = "/return/upload-image-next"
      break
    case "three":
      eventAction = "returnItem:UpdateContact:Next"
      eventName = "returnItem:UpdateContact:Next"
      eventMsg = "user proceeded to update contact information"
      internalLinkName = "return update contact next"
      internalLinkType = "return:updateContact:next"
      internalLinkURL = "/return/contact-info"
      break
    default:
      eventAction = "returnItem:FinalSubmit"
      eventName = "returnItem:FinalSubmit"
      eventMsg = "user submitted final return request"
      internalLinkName = "return final submit"
      internalLinkType = "return:finalSubmit"
      internalLinkURL = "/return/final-submit"
      break
  }
  const eventInfo = {
    eventAction: eventAction,
    eventName: eventAction,
    eventType: "form interaction",
    eventMsg: eventMsg,
    eventStatus: "success",
    internalLinkName: internalLinkName,
    internalLinkPosition: "return page",
    internalLinkType: internalLinkType,
    internalLinkZoneName: "return:form",
    internalLinkURL: internalLinkURL,
    clickInternalLinks: "true",
  }
  const returnInfo = {
    productID: productId,
    productName: productName,
    productCategory: productCategory,
    productColor: productDescription,
    productDimensions: productDimension,
    returnReason: returnData,
    returnQuantity: quantity,
    productPrice: quantityTotalPrice,
    currency: "INR",
    ...(isFaultyAvailable && { imageAttached: true }),
    ...(isFaultyAvailable && { imageCount: faultyData.length }),
  }
  const orderInfo = {
    basePrice: basePrice,
    taxAmount: taxAmount,
    shipping: 0.0,
    totalAmount: totalAmount,
    currency: currency,
    shippingMethod: "ground",
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    returnInfo,
    ...(step === "four" && { orderInfo }),
    page,
  })
}
